import { DELETE, GET, POST, PUT } from "./api";

const table = "campaigns";

export const Create = async (params) => {
  return await POST(`/${table}`, params, true);
};

export const Read = async (id) => {
  return await GET(
    `/${table}?filters[user]=${id}&populate=*&pagination[pageSize]=10000`,
    true
  );
};

export const ReadAll = async () => {
  return await GET(`/${table}?populate=*&pagination[pageSize]=10000&sort=createdAt:desc`, true);
};

export const ReadOne = async (id) => {
  return await GET(
    `/${table}/${id}?populate[0]=*&populate[deliveries][populate][1]=ratedBy&populate[deliveries][populate][2]=uploadBy&populate[deliveries][populate][3]=file&populate[projects_files][populate][3]=file&populate=user&populate[createdBy]=*`,
    true
  );
};

export const Update = async (params, id) => {
  return await PUT(`/${table}/${id}`, params, true);
};

export const Delete = async (id) => {
  return await DELETE(`/${table}/${id}`, true);
};
